import Vue from "vue";
import Router from "vue-router";
import Index from "@/index/index";
import Login from "@/login/Login";
import store from "@/store/index";
import wechatAuth from "../utils/wechatAuth";
const qs = require("qs");
import Details from "@/details/Details";
import Upload from "@/upload/Upload";
import Works from "@/works/Works";
import Register from "@/register/Register";
import My from "@/my/Pages/My";
import Message from "@/my/Pages/Message";
import BindWeChat from "@/my/Pages/BindWeChat";
import WorkDetails from "@/workdetails/WorkDetails";
import Reset from "@/resetpassword/reset";
import BindPhone from "@/bindphone/phone";
import SearchActivity from "@/searchactivity/SearchActivity";

Vue.use(Router);
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

var router = new Router({
  routes: [
    {
      path: "/",
      name: "Index",
      // component: Index
      component: () => import("../pages/home/home.vue")
    },
    {
      path: "/ogran/:id",
      name: "Index",
      // component: Index
      component: () => import("../pages/home/home.vue")
    },
    {
      path: "/custom-upload/:id",
      name: "custom-upload",
      component: () => import("../pages/custom-upload/custom-upload.vue")
    },
    {
      path: "/login",
      name: "Login", //跳转名称
      component: Login //和上面的login对应进行跳转
    },
    {
      path: "/details/:id",
      name: "Details",
      component: Details
    },
    {
      path: "/upload/:id",
      name: "Upload",
      component: Upload
    },
    {
      path: "/upload_426/:id",
      name: "upload_426",
      component: () => import("../test/upload_426/index.vue")
    },
    {
      path: "/works/:id",
      name: "Works",
      component: Works
    },
    {
      path: "/register",
      name: "Register",
      component: Register
    },
    {
      path: "/my",
      name: "My",
      component: My
    },
    {
      path: "/message",
      name: "Message",
      component: Message
    },
    {
      path: "/bindwechat",
      name: "BindWeChat",
      component: BindWeChat
    },
    {
      path: "/edituserinfo",
      name: "EditUserInfo",
      component: () => import("../my/Pages/EditUserInfo")
    },
    {
      path: "/workdetails/:id/:type",
      name: "WorkDetails",
      component: WorkDetails
    },
    {
      path: "/reset",
      name: "Reset",
      component: Reset
    },
    {
      path: "/phone",
      name: "BindPhone",
      component: BindPhone
    },
    {
      path: "/activity/:keyword",
      name: "SearchActivity",
      component: SearchActivity
    },
    {
      path: "/videonote",
      name: "videoNote",
      component: () => import("../pages/videoNote/videoNote.vue")
    },
    {
      path: "/notedetail",
      name: "noteDetail",
      props: route => ({ query: route.query.id }),
      component: () => import("../pages/noteDetail/noteDetail.vue")
    },
    {
      path: "/knowing",
      name: "knowing",
      component: () => import("../pages/knowing/knowing.vue")
    },
    {
      path: "/knowingdetail",
      name: "knowingdetail",
      props: route => ({ query: route.query.id }),
      component: () => import("../pages/knowingDetail/knowingDetail.vue")
    },
    {
      path: "/greenwrite",
      name: "greenwrite",
      // props: route => ({query: route.query.id }),
      component: () => import("../pages/greenWrite/greenWrite.vue")
    },
    {
      path: "/greenwritedetail",
      name: "greenwritedetail",
      props: route => ({ query: route.query.id }),
      component: () => import("../pages/greenWriteDetail/greenWriteDetail")
    },
    {
      path: "/deepread",
      name: "deepread",
      props: route => ({
        query: route.query.id,
        tab: +route.query.tab,
        type: route.query.type ? route.query.type : ""
      }),
      component: () => import("../pages/deepRead/deepRead")
    },
    {
      path: "/deepread-book/:bookId",
      name: "deepread-book",
      props: route => ({ bookId: route.params.bookId }),
      component: () => import("../pages/deepReadPublic/index.vue")
    },
    {
      path: "/greenlisten",
      name: "greenlisten",
      component: () => import("../pages/greenListen/greenListen.vue")
    },
    {
      path: "/pastbook",
      name: "pastbook",
      component: () => import("../pages/pastBook/pastBook.vue")
    },
    // {
    //   path: '/epubread',
    //   name:'epubread',
    //   props:route => ({query: route.query.url}),
    //   // component: () => import('../pages/deepRead/epubRead.vue')
    //   component: () => import("../pages/deepRead/epubRead_copy.vue")
    // },
    {
      path: "/mycollect",
      name: "mycollect",
      component: () => import("../my/Pages/myCollect.vue")
    },
    {
      path: "/qqwriteupload",
      name: "qqwriteupload",
      props: route => ({ type: route.query.type ? route.query.type : "" }),
      component: () => import("../pages/qqWriteUpload/qqWriteUpload.vue")
    },
    {
      path: "/myqqwriteworks",
      name: "myqqwriteworks",
      component: () => import("../my/Pages/MyqqWrite.vue")
    },
    {
      path: "/home",
      name: "home",
      component: () => import("../pages/home/home.vue")
    },
    {
      path: "/epub-read",
      name: "read",
      component: () => import("@/pages/read/epub-read.vue")
      // component: epubReadVue,
    },
    {
      path: "/pdf-read",
      name: "pdf-read",
      component: () => import("@/pages/read/pdf-read.vue")
      // component: pdfReadVue,
    },
    {
      path: "/awardWorks",
      name: "awardWorks",
      props: route => ({
        activeIndex: route.query.activeIndex ? +route.query.activeIndex : 0
      }),
      component: () => import("../pages/awardWorks/awardWorks.vue")
    },
    {
      path: "/401",
      name: "401",
      component: () => import("../pages/error-page/401.vue")
    },
    {
      path: "/clocksubmit",
      name: "clocksubmit",
      component: () => import("../pages/clockIn/clocksubmit"),
      props: route => ({ activityId: route.query.id })
    },
    {
      path: "/clockin",
      name: "clockin",
      component: () => import("../pages/clockIn/clock"),
      redirect: "/clockin/rank",
      props: route => ({ activityId: route.query.id }),
      children: [
        {
          path: "rank",
          name: "clockrank",
          meta: {
            nav: "rank"
          },
          component: () => import("../pages/clockIn/page/clockRank")
        },
        {
          path: "read",
          name: "clockread",
          meta: {
            nav: "read"
          },
          component: () => import("../pages/clockIn/page/clockRead")
        },
        {
          path: "my",
          name: "clockmy",
          meta: {
            nav: "clockmy"
          },
          component: () => import("../pages/clockIn/page/clockMy")
        },
        {
          path: "agencies",
          name: "agenciesRank",
          meta: {
            nav: "agencies"
          },
          component: () => import("../pages/clockIn/page/agenciesRank")
        }
      ]
    },
    {
      path: "/answer-activity",
      name: "answer-activity",
      component: () => import("../pages/answer-activity/index.vue")
    },
    {
      path: "/expert",
      name: "expert",
      component: () => import("../pages/expert-lib/index.vue")
    },
    {
      path: "/expert-detail",
      name: "expert-detail",
      component: () => import("../pages/expert-lib/pages/detail.vue")
    },
    {
      path: "/expert-apply",
      name: "expert-apply",
      component: () => import("../pages/expert-lib/pages/expert-apply.vue")
    },
    {
      path: "/award-works",
      name: "award-works",
      component: () => import("../my/Pages/awards-works.vue")
    },
    {
      path: "/expert-about",
      name: "expert-about",
      component: () => import("../pages/expert-lib/pages/about.vue")
    },
    {
      path: "/expert-news",
      name: "expert-news",
      component: () => import("../pages/expert-lib/pages/news.vue")
    },
    {
      path: "/news-detail",
      name: "news-deaill",
      component: () => import("../pages/expert-lib/pages/news-detail.vue")
    },
    {
      path: "/topic-lib",
      name: "topic-lib",
      component: () => import("../pages/topic-lib/index.vue"),
      redirect: "/topic-lib/detail",
      children: [
        {
          path: "detail/:id",
          name: "topic-lib-detail",
          component: () => import("../pages/topic-lib/pages/detail/index.vue")
        },
        {
          path: "rank/:id",
          component: () => import("../pages/topic-lib/pages/rank/index.vue")
        },
        {
          path: "answer/:id",
          component: () => import("../pages/topic-lib/pages/answer/index.vue")
        }
      ]
    },
    {
      path: "/mine",
      name: "mine",
      component: () => import("../my/index.vue"),
      redirect: "/mine/works",
      children: [
        {
          path: "userinfo",
          name: "mine-userinfo",
          component: () => import("../my/Pages/userinfo/index.vue")
        },
        {
          path: "works",
          name: "mine-works",
          component: () => import("../my/Pages/my-works/index.vue")
        },
        {
          path: "qqwrite",
          name: "mine-qqwrite",
          component: () => import("../my/Pages/qq-write/index.vue")
        },
        {
          path: "message",
          name: "mine-message",
          component: () => import("../my/Pages/message/index.vue")
        },
        {
          path: "bind-wechat",
          name: "bind-wechat",
          component: () => import("../my/Pages/bind-wechat/index.vue")
        },
        {
          path: "collect",
          name: "mine-collect",
          component: () => import("../my/Pages/collect/index.vue")
        },
        {
          path: "award-works",
          name: "award-works",
          component: () => import("../my/Pages/award-works/index.vue")
        }
      ]
    },
    {
      path: "/book-list/:id",
      name: "book-list",
      component: () => import("../pages/hainan/book-list/index.vue")
    },
    {
      path: "/book-detail/:activityId/:id",
      name: "book-detail",
      component: () => import("../pages/hainan/book-detail/index.vue")
    },
    {
      path: "/detail-richtext/:id",
      name: "detail-richtext",
      component: () => import('../pages/detail-richtext/index.vue')
    },
  ]
});
// router.beforeEach((to, from, next) => {
//   if (store.state.loginStatus == 0) {
//     //微信未授权登录跳转到授权登录页面
//     let url = window.location.href;
//     //解决重复登录url添加重复的code与state问题
//     let parseUrl = qs.parse(url.split('?')[1]);
//     let loginUrl;
//     if (parseUrl.code && parseUrl.state) {
//       delete parseUrl.code;
//       delete parseUrl.state;
//       loginUrl = `${url.split('?')[0]}?${qs.stringify(parseUrl)}`;
//     } else {
//       loginUrl = url;
//     }
//     // wechatAuth.redirect_uri = loginUrl;
//     // store.dispatch('setLoginStatus', 1);
//     // window.location.href = wechatAuth.authUrl
//   } else if (store.state.loginStatus == 1) {
//     try {
//       wechatAuth.returnFromWechat(to.fullPath);
//     } catch (err) {
//       store.dispatch('setLoginStatus', 0)
//       next()
//     }
//     store.dispatch('loginWechatAuth', wechatAuth.code).then((res) => {
//       console.log(res)
//       if (res.status == 1) {
//         store.dispatch('setLoginStatus', 2)
//       } else {
//         store.dispatch('setLoginStatus', 0)
//       }
//       next()
//     }).catch((err) => {
//       next()
//     })
//   }else {
//     next()
//   }
// });
//
// router.beforeEach((to, from, next) => {
//   let token = sessionStorage.getItem("token")

// if(window.location.href.indexOf('code')>=0){
//   //如果url中包含code,则保存到store中
//   let code = window.location.href.split("?")[1];
//   code = code.substring(5,code.indexOf('&'));
//   store.state.code = code;
// }

// if(to.path == '/login' && token) {
//   next('/')
//   return false
// }
// else if(to.path != '/login'){
//   // 第一次进入项目
//   //store.state.beforeLoginUrl = to.fullPath; // 保存用户进入的url
//   next('/login')
//   return false
// }else if(!store.state.user && to.path != '/login'){
//   // 之前有获取过授权
//   store.state.base_url = window.location.href+'/login';
//   console.log(store.state.base_url)
//
//   next('/login')
//   return false
// }
// next()
// })

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js